import React from "react";

interface ForbiddenPageProps {}

const ForbiddenPage: React.FC<ForbiddenPageProps> = () => {
  return <div>forbidden </div>;
};

export default ForbiddenPage;
